import C5BaseDAO from "./C5BaseDAO";
import UsuarioModel from "../../model/UsuarioModel";
import ProdutoModel from "../../model/ProdutoModel";
import LojaModel from "../../model/LojaModel";
import ListaModel from "../../model/ListaModel";
import ListaItemModel from "../../model/ListaItemModel";

class C5ListaUsuarioDAO extends C5BaseDAO {
  private static instance: C5ListaUsuarioDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): C5ListaUsuarioDAO {
    if (!C5ListaUsuarioDAO.instance) {
      C5ListaUsuarioDAO.instance = new C5ListaUsuarioDAO();
    }
    return C5ListaUsuarioDAO.instance;
  }

  public async obterListas(
    usuario: UsuarioModel,
    loja: LojaModel
  ): Promise<ListaModel[]> {
    const url: string = `${this.endpoint}/ClientShopList?ClientID=${usuario.clienteId}&StoreID=${loja.lojaId}`;
    return this.get("REQ_C5_LISTA_CONSULTA", url).then((resp: any) => {
      return resp.data.map((item: any) => {
        let x: number = 0;
        return {
          nome: item.ShopListName,
          listaId: item.ShopListID.toString(),
          items: item.ItensShopList.map((product: any) => {
            return {
              adicionado: new Date(Date.parse(item.Date)),
              listaItemId: (++x).toString(),
              notas: "",
              produto: ProdutoModel.toModelList(product),
              quantidade: +product.QuantityShopList,
            } as ListaItemModel;
          }),
        } as ListaModel;
      });
    });
  }

  public async cadastrarLista(
    usuario: UsuarioModel,
    nome: string
  ): Promise<any> {
    return this.post(
      "REQ_C5_LISTA_CADASTRO",
      `${this.endpoint}/ClientShopList`,
      {
        ClientID: usuario.clienteId,
        ShopListName: nome,
      }
    );
  }

  public async removerLista(
    usuario: UsuarioModel,
    listaId: string
  ): Promise<any> {
    return this.delete(
      "REQ_C5_LISTA_REMOVER",
      `${this.endpoint}/ClientShopList`,
      {
        ClientID: usuario.clienteId,
        ShopListID: listaId,
      }
    );
  }

  public async cadastrarItem(
    usuario: UsuarioModel,
    listaId: string,
    produto: ProdutoModel,
    qtd: number
  ): Promise<any> {
    return this.post(
      "REQ_C5_LISTA_ITEM_ADICIONAR",
      `${this.endpoint}/ClientShopListItem`,
      {
        ClientID: usuario.clienteId,
        ShopListID: listaId,
        ProductID: produto.produtoId,
        QuantityItemShopList: qtd,
      }
    );
  }

  public async atualizarItem(
    usuario: UsuarioModel,
    listaId: string,
    produto: ProdutoModel,
    qtd: number
  ): Promise<any> {
    return this.post(
      "REQ_C5_LISTA_ITEM_ATUALIZAR",
      `${this.endpoint}/ClientShopListItem`,
      {
        ClientID: usuario.clienteId,
        ShopListID: +listaId,
        ProductID: produto.produtoId,
        QuantityItemShopList: qtd,
      }
    );
  }

  public async removerItem(
    usuario: UsuarioModel,
    listaId: string,
    produto: ProdutoModel
  ): Promise<any> {
    return this.delete(
      "REQ_C5_LISTA_ITEM_EXCLUIR",
      `${this.endpoint}/ClientShopListItem`,
      {
        ClientID: usuario.clienteId,
        ShopListID: listaId,
        ProductID: produto.produtoId,
      }
    );
  }
}

export default C5ListaUsuarioDAO;
